import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import axios from 'axios';

function AddCustomer({ onClose, editData, apiUrl }) {
    const [formValues, setFormValues] = useState({
        customer_name: '',
        mobile_no: '',
        address: '',
        is_active: true,
    });

    useEffect(() => {
        if (editData) {
            setFormValues({
                customer_name: editData.customer_name || '',
                mobile_no: editData.mobile_no || '',
                address: editData.address || '',
                is_active: editData.is_active === 1,
            });
        }
    }, [editData]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                ...formValues,
                is_active: formValues.is_active ? 1 : 0
            };

            if (editData?.customer_id) {
                payload.customer_id = editData.customer_id;
            }

            await axios.post(apiUrl, payload);
            onClose();
        } catch (err) {
            console.error("Error saving customer:", err);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title">{editData ? 'Update Customer' : 'Add New Customer'}</span>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <Row className="mb-3">
                            <Col md={6}>
                                <label>Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    name="customer_name"
                                    value={formValues.customer_name}
                                    onChange={handleInputChange}
                                    required
                                    className="form-control"
                                />
                            </Col>
                            <Col md={6}>
                                <label>Mobile No <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    name="mobile_no"
                                    value={formValues.mobile_no}
                                    onChange={handleInputChange}
                                    required
                                    className="form-control"
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={12}>
                                <label>Address</label>
                                <textarea
                                    name="address"
                                    value={formValues.address}
                                    onChange={handleInputChange}
                                    className="form-control"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Form.Check
                                    type="switch"
                                    id="isActiveSwitch"
                                    name="is_active"
                                    label="Is Active?"
                                    checked={formValues.is_active}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCustomer;
